import {baseKeysUseQuery} from '#/hooks/query/base/base-keys-use-query';
import {apiPortfolioRequests} from '#/repository/api-portfolio-requests';
import {shouldWaitlistNetDisplayNullUserAssets} from '#/utils/should-waitlist-net-display-null-user-assets';
import {Hex, TransactionPortfolioValue} from '@shareland/shareland-common';
import {useQuery} from '@tanstack/react-query';

export const usePortfolioLandAssets = (account: Hex | undefined) =>
  useQuery({
    queryKey: [baseKeysUseQuery.usePortfolioLandAssets, account],
    queryFn: () =>
      shouldWaitlistNetDisplayNullUserAssets(account!)
        ? ([] as TransactionPortfolioValue[])
        : apiPortfolioRequests.getLandAssets({account: account!}),
    refetchOnMount: 'always',
    enabled: !!account,
  });
